import groq from "groq";

/**
 * Query for reviews by office ID. Order by rank ascending.
 * Filter out hidden reviews.
 */
export const ReviewQueryByRank = groq`
*[_type == "review" && officeID == $officeID && hideReviewOverride != true] | order(rank asc) {
  _id,
  reviewID,
  officeID,
  franchiseID,
  rank,
  reviewDate,
  reviewerName,
  reviewRating,
  reviewContent,
  reviewLanguage,
  reviewPlatform,
  hideReviewOverride
}
`;
